import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { News } from 'src/app/models/obs/news';
import { Log } from 'src/app/models/user-log';
import { AccessService } from 'src/app/services/access.service';
import { NewsService } from 'src/app/services/obs/news.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import { UtilLogService } from 'src/app/services/util/util-log.service';

@Component({
  selector: 'app-admnews-form',
  templateUrl: './admnews-form.component.html',
  styleUrl: './admnews-form.component.scss'
})
export class AdmnewsFormComponent implements OnInit {

  form: FormGroup;
  news: News = null;

  edit: boolean = false;
  idtier3Selected: number = null;
  isUploadDir: boolean = false;
  filename: string = null;
  URL: string = urlEndPoint;
  uploatedFile: File;

  dataLog = {};
  movesLog: Log[] = null;
  accessMP: boolean = false;
  inf = {}
  constructor(
    private accesService: AccessService,
    private ts: TokenStorageService,
    private router: Router,
    private newS: NewsService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private userLogService: UserLogService,
    private utilLogservice: UtilLogService,
    private uploadS: UploadfileService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getNew(params);
    this.getPermission();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      ideditor: [null],
      title: ['', Validators.required],
      autor: ['', Validators.required],
      date: ['', Validators.required],
      content: ['', Validators.required],
      source: ['', Validators.required],
      img: [],
      tags: [],
      type: [0],
      status: [],
      dateexpiry: ['']
    })
  }

  verifiedImgDirectory() {
    if (this.news.img != null) {
      (this.news.img.substring(1, 7) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  getNew(params: any) {
    if (params.id) {
      this.newS.getOne(params.id).subscribe({
        next: res => {
          this.news = res['data'];
          this.getLog();
          this.verifiedImgDirectory();
          this.loadData();
          this.edit = true;
        },
        error: err => console.error(err)
      });
    } else {
      this.edit = false;
    }
  }

  loadData() {
    this.form.reset(this.news);
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.form.get('img').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }


  cancel() {
    this.router.navigate(['/adm/actualidad/list']);
  }

  save() {
    if (this.form.invalid) {
      console.log("Formulario inválido");
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFile != null) ? this.onUpload() : this.saveOrUpdate();
    }
  }

  onUpload() {
    let formData = new FormData();
    formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
    this.uploadS.uploadFile(formData).subscribe((res) => {
      this.filename = res['filename'];
      this.saveOrUpdate();
    });
  }
  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    this.router.navigate(['/adm/actualidad/list']);
  }

  create(news: News) {
    delete news.id;
    if (this.filename) { news.img = '/uploads/' + this.filename; }
    if (!news.dateexpiry) {
      news.dateexpiry = null;
    }
    this.newS.createNews(news).subscribe({
      next: res => { if (res) this.utilLogservice.createLog(res['data'], 'creación', 'Lista actualidad'); },
      error: err => { console.error(err) }
    });
  }

  update(id: string, news: News) {
    const data = { ...news };
    delete news.id;
    if (this.filename) {
      news.img = '/uploads/' + this.filename;
      console.log("filename in update: ", this.filename);
    }
    if (!news.dateexpiry) {
      news.dateexpiry = null;
    }
    this.newS.updateNews(id, news).subscribe({
      next: res => { if (res) this.utilLogservice.createLog(data, 'edición', 'Lista actualidad'); },
      error: err => { console.error(err) }
    });
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  /* Obtener ultimos moviemientos de los usuarios en el compoente */
  getLog() {
    const term = this.activedRoute.snapshot['_routerState'].url.split('/')[2];
    const idContent = this.activedRoute.snapshot.params['id'];
    this.userLogService.getLastLogByContent(idContent, term).subscribe(
      res => { this.movesLog = res['data'] || []; },
      err => console.error(err)
    );
  }

  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 12;//este id es del modulo de reportes
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'] ? true : false;
      }
    });
  }

}
